var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div ng-if=\"::allForced\">\nNothing to configure here. You can check the\n<a ng-click=\"changeToHierarchyTab()\" href=\"javascript:void(0);\">inheritance hierarchy</a>.\n</div>\n</div>";
var id1="component/control-config-directive/control-config-directive.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;